// Takes in dictionary of screenData and parses out a key
function getScreenDataKeyValue(
  screenData: { [index: string]: string },
  key: string
): string {
  if (screenData == null) {
    return "";
  }

  let result = screenData[key];
  if (result === undefined || result === null) {
    result = "";
  }

  return result;
}

export default getScreenDataKeyValue;
